import { useQuery } from '@tanstack/react-query';
import { useBusiness, type BusinessView } from '@/contexts/BusinessContext';
import { getAllVisitsWithEvidence, type VisitWithEvidence } from '@/services/visits';

// ===========================================
// Query Keys
// ===========================================

export const visitsKeys = {
  all: ['visits'] as const,
  withEvidence: (business: BusinessView, searchQuery?: string) =>
    [...visitsKeys.all, 'evidence', business, searchQuery] as const,
};

// ===========================================
// Query Hooks
// ===========================================

/**
 * Get all visits that have evidence photos (for Evidence Library)
 */
export function useVisitsWithEvidence(searchQuery?: string) {
  const { currentBusinessView } = useBusiness();

  return useQuery({
    queryKey: visitsKeys.withEvidence(currentBusinessView, searchQuery),
    queryFn: async () => {
      const result = await getAllVisitsWithEvidence({
        business: currentBusinessView,
        searchQuery,
        limit: 200,
      });

      if (!result.success) {
        throw new Error(result.error || 'Failed to fetch visits with evidence');
      }

      return result.visits || [];
    },
    staleTime: 1000 * 60, // 1 minute
  });
}
